import axios from "axios";
import { toast } from "react-toastify";

import { TicketFilter } from "./ticketFilter";

const FILTERS_API_URL = `${process.env.REACT_APP_API_BASE_URL}/filters`;

export const fetchTicketFilters = async () => {
  try {
    const response = await axios.get(`${FILTERS_API_URL}`);
    const filters = response.data.map(mapApiTicketFilter);
    return filters;
  } catch (err) {
    return [];
  }
};

export const fetchTicketFilter = async (filterId: string) => {
  const response = await axios.get(`${FILTERS_API_URL}`, {
    params: {
      filterId,
    },
  });
  const ticketFilter = mapApiTicketFilter(response.data);
  return ticketFilter;
};

export const createTicketFilter = async (ticketFilter: TicketFilter) => {
  const payload = {
    data: JSON.stringify(ticketFilter),
  };
  const response = await axios.post(FILTERS_API_URL, payload);
  const newFilter = mapApiTicketFilter(response.data);
  toast.success("Filtrul a fost creat cu succes!");
  return newFilter;
};

export const updateTicketFilter = async (ticketFilter: TicketFilter) => {
  const payload = {
    id: ticketFilter.id,
    data: JSON.stringify(ticketFilter),
  };
  await axios.put(`${FILTERS_API_URL}`, payload);
  toast.success("Filtrul a fost actualizat cu succes!");
};

export const deleteTicketFilter = async (ticketFilter: TicketFilter) => {
  await axios.delete(`${FILTERS_API_URL}/${ticketFilter.id}`);
  toast.success("Filtrul a fost sters cu succes!");
};

const mapApiTicketFilter = (ticketFilter: any): TicketFilter => {
  const data = JSON.parse(ticketFilter?.data || "{}");
  const mappedFilter: TicketFilter = {
    id: `${ticketFilter.id}`,
    name: data.name,
    departmentId: data.departmentId,
    agentId: data.agentId,
    locationIds: data.locationIds,
    statusIds: data.statusIds,
    teamIds: data.teamIds,
    grandParentCategoryIds: data.grandParentCategoryIds,
    parentCategoryIds: data.parentCategoryIds,
    categoryIds: data.categoryIds,
  };
  return mappedFilter;
};
